<template>
    <div class="tab-pane fade">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: "NavTabPane"
}
</script>